import { SpinningLoader } from "risa-oasis-ui_v2";

const LoadingState = () => {
  return (
    <div className="flex h-full w-full items-center justify-center gap-4">
      <SpinningLoader />
      <div className="text-body">Fetching forms...</div>
    </div>
  );
};

export default LoadingState;
